const MuiTabs = {
  styleOverrides: {
    indicator: {
      height: "4px"
    }
  }
};

export default MuiTabs;
